import {toast} from "react-toastify";

export default {
    token: localStorage.getItem("token") ? localStorage.getItem("token").length > 3 ? localStorage.getItem("token") : "" : "",
    api: "https://api.nazifchi.ir",

    handleError: (err) => {
        let error = "";
        if (err) {
            if (err.response) {
                if (err.response) {
                    if (err.response.data) {
                        const {message} = err.response.data;
                        if (message) {
                            error = message;
                        }
                    }
                }
            }
        }
        if (error === "") {
            error = "خطایی رخ داده است!"
        }

        toast.error(error);
        return error;
    },

    hasAccess: (permissions, permission) => {
        return permissions.length === 0 || permissions.includes(permission);
    },
    scrollTop: () => {
        try {
            if (window) {
                window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
            }
        } catch (err) {
        }
    },
    priceFormatter: (price) => {
        let mPrice = typeof price === "string" ? Number(price) : price;
        let formatter = new Intl.NumberFormat('fa-IR', {
            style: 'currency',
            currency: 'IRT',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });
        return formatter.format(mPrice).replace("IRT", "").toString().trim() + " تومان";
    }
}